import { getSessionId } from "../../utils/index";
import { ANALYTICS_SCRIPT } from "../../src/config/getEnvironmentVars";
import { analyticsTags } from "./AnalyticsTags";
import { EventType, PageRoute } from "./enums";

const analyticsScript = ANALYTICS_SCRIPT;

let isEmbed = false;
//Includes Adobe Analytics DTM script in <head> tag to capture events
export const initializeAnalytics = (embed: string) => {
  if (embed?.indexOf('/') >= 0) {
    let embedCheck = embed.split('/');
    let embedID = embedCheck[embedCheck.length - 1];
    let embedIDxmin = embedID.replace('min.', '');

    const existingScript1 = document.querySelector(`script[src*='${embedID}']`);
    const existingScript2 = document.querySelector(
      `script[src*='${embedIDxmin}']`,
    );

    if (existingScript1 || existingScript2) {
      isEmbed = true;
    } else {
      const script = document.createElement('script');
      script.setAttribute('src', analyticsScript);
      document.head.appendChild(script);
    }
  }
  
};
const getPageTagsForCurrentRoute = (route:any) => {
  if (route === PageRoute.TaxDocuments) {
    return analyticsTags.TaxDocPageViewTags;
  }
  // Add other routes and their corresponding tags
  if (route === PageRoute.PensionVerification) {
    return analyticsTags.PVLPageViewTags;
  }
  return analyticsTags.TaxDocPageViewTags; // Default to login tags if route not found
};
export const trackPage = (pagepayload:any) => {
  initializeAnalytics(analyticsScript);
  window.oneAmerDataLayer = window.oneAmerDataLayer ?? [];
  if (window?.oneAmerDataLayer[0]?.data?.page?.name !== pagepayload.name) {
    let eventObj = {
      event: EventType.PageView,
      data: {
        page: {
          name: pagepayload.name,
          type: pagepayload.type,
          section: pagepayload.section,
          section1: pagepayload.section1,
          section2: pagepayload.section2,
          section3: pagepayload.section3,
          lob: pagepayload.lob,
          persona: pagepayload.persona,
          productCategory: pagepayload.productCategory,
          productType: pagepayload.productType,
        },
        environment: {
          language: pagepayload.language,
          sitetype: pagepayload.siteType,
        },
      },
    };
    window.oneAmerDataLayer.push(eventObj);
  }
};

// function for tracking custom event starts here //
export const trackCustomEvent = (customEventTags:any) => {
  initializeAnalytics(analyticsScript);
  // Get the current route
  const currentRoute = window?.location?.pathname;
  // Get the corresponding page tags based on the current route
  const pageTags = getPageTagsForCurrentRoute(currentRoute);
  const xoaSessionId = getSessionId();

  let eventObj = {
    event: EventType.CustomEvent,
    data: {
      page: pageTags,
      target: {
        name: customEventTags.name,
        value: customEventTags.value,
        type: customEventTags.type,
      },
      XOASessionID: xoaSessionId,
    },
  };
  window.oneAmerDataLayer.push(eventObj);
};
